import React, { useState, useEffect } from "react";
import { View, Text, StyleSheet } from "react-native";
import RangeSliderComponent from "../../../../../components/GlobalComponents/Sliders/RangeSliderComponent";
import AsyncStorage from "@react-native-async-storage/async-storage";

export default function AgeFilter({
  filters,
  setFilters,
}: {
  filters: any;
  setFilters: any;
}) {
  const [firstValue, setFirstValue] = useState(18);
  const [secondValue, setSecondValue] = useState(99);

  useEffect(() => {
    // Update the slider values based on the initial filters
    setFirstValue(filters.basicFilters.ageRange.min);
    setSecondValue(filters.basicFilters.ageRange.max);
  }, [filters.basicFilters.ageRange]);

  const handleAgeRangeChange = (minValue: any, maxValue: any) => {
    setFirstValue(minValue);
    setSecondValue(maxValue);
  
    setFilters((prevFilters: any) => {
      const updatedFilters = {
        ...prevFilters,
        basicFilters: {
          ...prevFilters.basicFilters,
          ageRange: {
            min: minValue,
            max: maxValue,
          },
        },
      };
  
      // Save the updated state to AsyncStorage
      AsyncStorage.setItem("filters", JSON.stringify(updatedFilters));
  
      return updatedFilters;
    });
  };
  
  const handleFromValueChange = (value: any) => {
    handleAgeRangeChange(value, secondValue);
  };
  
  const handleToValueChange = (value: any) => {
    handleAgeRangeChange(firstValue, value);
  };

  return (
    <View
      style={{
        width: "100%",
        position: "relative",
      }}
    >
      <RangeSliderComponent
        min={18}
        max={99}
        initialFromValue={firstValue}
        initialToValue={secondValue}
        onFromValueChange={handleFromValueChange}
        onToValueChange={handleToValueChange}
      />
      <View style={styles.valueLabelsContainer}>
        <Text style={styles.valueLabel}>{firstValue}</Text>
        <Text style={styles.valueLabel}>{secondValue}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  valueLabelsContainer: {
    width: "100%",
    display: "flex",
    marginTop: -45,
    paddingHorizontal: 15,
    justifyContent: "space-between",
    flexDirection: "row",
  },
  valueLabel: {
    color: "black",
  },
});
